import { newSize } from '@lessonup/pins-shared';

export const pinSize = newSize(960, 540);
